export default "__VITE_ASSET__DuWfTuYj__"